import Vue from "vue";
import Vuex from "vuex";

import modCore from "./modCore/index";
import modEditLetter from "./modEditLetter/index";
import modRequest from "./modRequest/index";
import modDemands from "./modDemands/index";
import modApproval from "./modApproval/index";
import modSettle from "./modSettle/index";
import modRightPetition from "./modRightPetition/index";
import modProcesses from "./modProcesses/index";
import modProcessEmployee from "./modProcessEmployee/index";
import modProcessDashboard from "./modProcessDashboard/index";
import modTipshiftReport from "./modTipshiftReport/index";
import modTipshiftReportHistory from "./modTipshiftReportHistory/index";
import modPlatformSettings from "./modPlatformSettings/index";
import modPayRollNews from "./modPayRollNews/index";
import modTipshiftPointSale from "./modTipshiftPointSale/index";
import modReportTips from "./modReportTips/index";
import modOhAnalyst from "./modOhAnalyst/index";
import modTipsEmployee from "./modTipsEmployee/index";
import modTipFileUpload from "./modTipFileUpload/index";
import modNovelties from "./modNovelties/index";
import modSVE from "./modSVE/index";
import modSVEMnet from "./modSVEMnet/index";
import modTrainingExtendedForm from "./modTrainingExtendedForm/index";
import modSiesaReport from "./Modules/siesa-report/index";
import modSiesaTips from "./Modules/siesa-tips/index";
import modLicenseTickets from "./Modules/license-tickets/index";
import modSettings from "./Modules/settings/index";
import modDiagnostics from "./modDiagnostics/index";
import modAuth from "./Modules/auth/index";
import modScenarios from "./modPlatformSettings/modScenario/index";
import modShiftReport from "./Modules/propinas/shift-report/index"
import htGes from "./Modules/health-tracker/ges/index"
import htGesV2 from "./Modules/health-tracker/ges/V2/index"
import useLegalMutations from './Modules/legal/index'
import permisosSindicalesStatisticsLaborsUnions from './Modules/permisos-sindicales/v2/statistics/labors-unios'
import healthTrackerAbsenteeismV2InformationManagement from './Modules/health-tracker/absenteeism/V2/information-management/index'
import healthTrackerAbsenteeismV2InformationManagementGraphic from './Modules/health-tracker/absenteeism/V2/information-management/graphics/index'
import healthTrackerCommonSelectorRisks from './Modules/health-tracker/v2/common/selectors/risks/risks-store'
import permisosSindicalesV2License from './Modules/permisos-sindicales/v2/licenses/licenses-store'
import permisosSindicalesV2LaborUnion from './Modules/permisos-sindicales/v2/labor-union/labor-union'

const { process } = useLegalMutations()

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    modCore: modCore,
    modEditLetter: modEditLetter,
    modRequest: modRequest,
    modDemands: modDemands,
    modApproval: modApproval,
    modSettle: modSettle,
    modRightPetition: modRightPetition,
    modProcesses: modProcesses,
    modProcessEmployee: modProcessEmployee,
    modProcessDashboard: modProcessDashboard,
    modTipshiftReport: modTipshiftReport,
    modTipshiftReportHistory: modTipshiftReportHistory,
    modPlatformSettings: modPlatformSettings,
    modPayRollNews: modPayRollNews,
    modTipshiftPointSale: modTipshiftPointSale,
    modReportTips: modReportTips,
    modOhAnalyst: modOhAnalyst,
    modTipsEmployee: modTipsEmployee,
    modTipFileUpload: modTipFileUpload,
    modNovelties: modNovelties,
    modSVE: modSVE,
    modSVEMnet: modSVEMnet,
    modTrainingExtendedForm: modTrainingExtendedForm,
    modSiesaReport,
    modSiesaTips,
    modLicenseTickets,
    modSettings,
    modAuth,
    modDiagnostics: modDiagnostics,
    modScenarios: modScenarios,
    modShiftReport,
    htGes,
    htGesV2,
    process,
    permisosSindicalesStatisticsLaborsUnions
    ,healthTrackerAbsenteeismV2InformationManagement
    ,healthTrackerAbsenteeismV2InformationManagementGraphic
    , healthTrackerCommonSelectorRisks
    , permisosSindicalesV2License
    , permisosSindicalesV2LaborUnion
  },
});
